// Shared helpers so API catch blocks never crash when Axios has no HTTP
// response (network drop, timeout, CORS, cancelled request, token refresh).

export function getApiErrorMessage(error, fallback) {
    const errorResponse = error?.response?.data
    if (typeof errorResponse === 'string' && errorResponse.trim()) {
        return errorResponse
    }
    if (errorResponse && typeof errorResponse === 'object') {
        return (
            errorResponse.message ||
            errorResponse.error ||
            fallback ||
            error.message
        )
    }
    if (error?.code === 'ERR_CANCELED' || error?.name === 'AbortError') {
        return error.message || 'Request was cancelled'
    }
    if (error?.code === 'ECONNABORTED' || error?.code === 'ERR_NETWORK') {
        return (
            fallback ||
            'Could not reach the server. Please check your connection and try again.'
        )
    }
    if (error?.request) {
        return (
            fallback ||
            'Could not reach the server (network error or the file may be too large). Please try again.'
        )
    }
    return error?.message || fallback || 'Unexpected error. Please try again.'
}

export function normalizeApiError(error) {
    if (!error || typeof error !== 'object') {
        return error
    }

    const message = getApiErrorMessage(error)
    if (!error.response) {
        error.response = {
            data: {
                message,
                error: message,
            },
        }
        return error
    }

    const data = error.response.data
    const hasMessage =
        (typeof data === 'string' && data.trim()) ||
        (data && typeof data === 'object' && (data.message || data.error))

    if (!hasMessage) {
        error.response.data = {
            ...(typeof data === 'object' && data !== null ? data : {}),
            message,
            error: message,
        }
    }

    return error
}

export function throwApiError(error, fallback) {
    if (error?.name === 'AbortError' || error?.code === 'ERR_CANCELED') {
        throw error
    }
    throw new Error(getApiErrorMessage(error, fallback))
}
